import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as BrushSvg } from './assets/brush.svg';

const BrushIcon = React.forwardRef((args, ref) => <SvgIcon component={BrushSvg} ref={ref} {...args} />);

export default BrushIcon;
